/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Status_AcknowledgedInputs */

const en_fulfillment_status_acknowledged = /** @type {(inputs: Fulfillment_Status_AcknowledgedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken by the warehouse`)
};

/**
* | output |
* | --- |
* | "Taken by the warehouse" |
*
* @param {Fulfillment_Status_AcknowledgedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_status_acknowledged = /** @type {((inputs?: Fulfillment_Status_AcknowledgedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Status_AcknowledgedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_status_acknowledged(inputs)
});